(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["navigation-bar"] && !window.DesignMode) return;
  try {
    
  const links = document.querySelectorAll('.navigation-bar__item');
  const barHeight = document.querySelector('.navigation-bar').clientHeight;

  // Highlight on scroll
  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;

    links.forEach(link => {
      const section = document.querySelector(`#${link.dataset.section}`);

      if (section) {
        if ((section.offsetTop - barHeight - 30) <= fromTop && (section.offsetTop - barHeight - 30) + section.clientHeight > fromTop) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });

  // Scroll to link
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const section = document.querySelector(`#${event.currentTarget.dataset.section}`)

      window.scrollTo({
        top: section.offsetTop - barHeight - 30,
        behavior: "smooth"
      });
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-menu"]) return;
  try {
    
  const height = $('#section-announcement').outerHeight() + $('#shopify-section-header').outerHeight();
  $('#sidebar-menu').css('top', height + 'px'); 

  } catch(e) { console.error(e); }
})();

})();
